<template>
    <div class="row q-gutter-lg justify-start items-center">
        <div class="">
            <app-editable-input
                :data="date.from"
                name="from"
                type="date"
                text="Start Date"
                textClasses="text-weight-bold"
                outlined
                @input="(d)=>handleInput('from', d.model)"
            />
        </div>
        <div class="">
            <app-editable-input
                :data="date.to"
                name="to"
                type="date"
                text="End Date"
                textClasses="text-weight-bold"
                outlined
                @input="(d)=>handleInput('to', d.model)"
            />
        </div>
        <div>
            <q-btn color="brand1" label="Apply" @click="handleApply" v-if="showSubmit"/>
        </div>
        <div class="error">
            <span v-if="error" class="text-brand4">{{error}}</span>
        </div>

    </div>
</template>
<script>
    import AppEditableInput from '@client/components/form/editable-input';

    export default {
        components: {
            AppEditableInput
        },
        props: {
            selectedRange: Object,
            showSubmit: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                date: {
                    from: this?.selectedRange?.from,
                    to: this?.selectedRange?.to
                },
                error: ''
            };
        },
        methods: {
            handleApply() {
                this.error = this.getRangeError();
                if (this.error) return;
                this.$emit('onApply', this.date);
                this.error = '';
            },
            handleInput(name, value) {
                this.date[name] = value;
                this.error = this.getRangeError();
            },
            getRangeError() {
                 return this.date.from > this.date.to ? `Invalid Date Range : ${this.date.from} - ${this.date.to}` : '';
            }
        }
    };
</script>
